import { IRootReducer } from '../../types/reducerTypes'

export const selectQuestions = ({ formQuestions }: IRootReducer) =>
  formQuestions.questions

export const selectCurrentQuestionIndex = ({ formQuestions }: IRootReducer) =>
  formQuestions.currentQuestionIndex

export const selectCurrentFormId = ({ formQuestions }: IRootReducer) =>
  formQuestions.formId

export const selectFormSubmission = ({ formQuestions }: IRootReducer) => {
  const { formSubmission, formId } = formQuestions
  return formSubmission[formId]
}
